import { Quote } from "lucide-react";
import Reveal from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/team";

export const Testimonials = () => (
  <section className="bg-konattu-cream py-24 md:py-32" data-testid="testimonials-section">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="font-mono text-xs tracking-[0.35em] text-konattu-red">/ WHAT CUSTOMERS SAY</span>
      </Reveal>
      {TESTIMONIALS.map((t) => (
        <Reveal key={t.name} delay={0.1}>
          <figure className="mt-10" data-testid="testimonial">
            <Quote size={44} className="text-konattu-red mb-6" />
            <blockquote className="font-display font-medium text-konattu-charcoal tracking-tight leading-[1.15] text-3xl md:text-5xl">
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-3">
              <span className="h-px w-10 bg-konattu-red" />
              <span className="font-mono text-sm tracking-[0.25em] text-konattu-charcoal/70 uppercase">{t.name}</span>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Testimonials;
